import { CONSTANTS } from './constants';


interface NamedItem {
  id: number;
  nameHE?: string;
  nameEN?: string;
}

interface SiteItem extends NamedItem {
  cityId?: number;
}

const getItemNameById = <T extends NamedItem>(
  id: number,
  items: T[],
  appLanguage: string
) => {
  if (items?.length && id) {
    const item = items.find(
      (curr: any) => curr.id === id
    );
    return (
      (appLanguage === CONSTANTS.DEFAULT_LANGUAGE
        ? item?.nameHE
        : item?.nameEN) ?? ''
    );
  }
  return '';
};

export const getCustomerSite = (
  siteId: number,
  siteListDetails: SiteItem[],
  appLanguage: string
) => {
  const siteName = getItemNameById(siteId, siteListDetails, appLanguage);
  return siteName ? `${siteId} - ${siteName}` : siteId;
};

export const getCustomerCity = <TSite extends SiteItem, TCity extends NamedItem>(
  siteId: number,
  siteListDetails: TSite[],
  cities: TCity[],
  appLanguage: string
) => {
  if (siteListDetails?.length && siteId) {
    const site = siteListDetails.find((s: any) => s.id === siteId);
    return site?.cityId ? getItemNameById(site.cityId, cities, appLanguage) : '';
  }
};

export const getCityById = <TCity extends NamedItem>(
  cityId: number,
  cities: TCity[],
  appLanguage: string
) => {
  return getItemNameById(cityId, cities, appLanguage);
};

export const getShippingCompanyNameById = <TShippingCompany extends NamedItem>(
  shippingCompanyId: number,
  shippingCompanies: TShippingCompany[],
  appLanguage: string
) => {
  return getItemNameById(shippingCompanyId, shippingCompanies, appLanguage);
};